module.exports = __webpack_public_path__ + "static/img/beats_studio.82fe02a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/Music/imgs/beats_studio.jpg
// module id = zF0R
// module chunks = 0